<template>
  <div class="c-table-cell" :style="backgroundColor" @click="displayCandidateStatusModal = true">
    <m-candidate-status
      :active="displayCandidateStatusModal"
      :candidate-id="data.candidateId"
      @close="displayCandidateStatusModal = false"
    />
    <div class="c-table__cell-value">
      <div>{{ data.value }}</div>
      <div v-if="data.candidateStatus.date" class="status-date">({{ data.candidateStatus.date }})</div>
      <candidates-scheduled-date
        v-if="data.candidateStatus.scheduledDate"
        :status-id="data.candidateStatus.value"
        :date="data.candidateStatus.scheduledDate"
      />
    </div>
  </div>
</template>

<script>
import CandidatesScheduledDate from "@/pages/staff/candidates/components/candidates-scheduled-date";
import CandidateStatus from "@/components/modals/candidate-status";
import candidateStatusMixin from "@/mixins/candidateStatusMixin";

export default {
  name: "status-cell",
  components: {
    "m-candidate-status": CandidateStatus,
    CandidatesScheduledDate,
  },
  mixins: [candidateStatusMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      displayCandidateStatusModal: false,
    };
  },
  computed: {
    backgroundColor() {
      let color = this.getStatusColor(this.data.candidateStatus.value);

      if (!color) {
        color = "#FFF";
      }

      return `background-color: ${color}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table-cell {
  cursor: pointer;
}
.c-table__cell-value {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.status-date {
  font-size: 11px;
}
</style>
